import {Injectable} from '@angular/core';
import {StateManagerService} from './state-manager.service';

@Injectable({
    providedIn: 'root'
})
export class FindActionDetailsService {

    constructor(private stateManager: StateManagerService) {
    }

    findOperatorName(id: number) {
        const operators = this.stateManager.getCollection('operator'); // .chain().find({cod: id}).data()[0];
        const operatorName = operators.find(operator => {
            return operator.cod === id;
        });
        return operatorName ? operatorName.username : 'Unknown User';
    }

    findPriorityDescr(priorityId: number) {
        const priorityDescList = this.stateManager.getCollection('actionpriority'); // .chain().find({id: priorityId}).data()[0];
        const priorityDesc = priorityDescList.find(priority => {
            return priority.id === priorityId;
        });
        return priorityDesc ? priorityDesc.description : 'Unknown Priority';
    }

    findActionTypeDesc(actionTypeId: number) {
        const actionTypeDescList = this.stateManager.getCollection('actiontype'); // .chain().find({id: actionTypeId}).data()[0];
        const actionTypeDesc = actionTypeDescList.find(actionType => {
            return actionType.id === actionTypeId;
        });
        return actionTypeDesc ? actionTypeDesc.description : 'Unknown Type';
    }
}
